const parseList = (envVal, defaultList) => {
	if (!envVal) return defaultList;
	const separator = envVal.includes(";") ? ";" : envVal.includes("|") ? "|" : ",";
	return envVal.split(separator).map(item => item.trim()).filter(Boolean);
};

const getRange = (startDate, endDate, defaultRange) => {
	if (startDate && endDate) {
		return `${startDate} – ${endDate}`;
	}
	return defaultRange;
};

export const profileData = {
	name: process.env.REACT_APP_NAME || "Krish Pithadiya",
	role: process.env.REACT_APP_ROLE || "Full Stack Developer",
	location: process.env.REACT_APP_LOCATION || "Jamnagar, Gujarat",
	email: process.env.REACT_APP_EMAIL || "your.email@example.com",
	phone: process.env.REACT_APP_PHONE || "+91 12345 67890",
	linkedin:
		process.env.REACT_APP_LINKEDIN || "https://linkedin.com/in/your-profile",
	github: process.env.REACT_APP_GITHUB || "https://github.com/your-username",
	resume: process.env.REACT_APP_RESUME_LINK || "/resume.pdf",
	headline:
		process.env.REACT_APP_HEADLINE ||
		"Building polished, high-performance applications with a high-end product mindset.",
	heroSummary:
		process.env.REACT_APP_SUMMARY ||
		"I blend clean interfaces and reliable backend systems into modern digital products.",
	heroHighlights: [
		"Responsive UI and component-driven design",
		"API-first backend architecture",
		"Database-powered workflows and integration",
	],
	aboutSummary:
		process.env.REACT_APP_ABOUT_PARAGRAPH ||
		"I deliver maintainable full-stack solutions with thoughtful UX, scalable code patterns, and collaborative engineering practices.",
	aboutPoints: [
		"Specialize in React and Spring / Django-based applications that feel polished and stable.",
		"Solve problems with reusable components, clean state handling, and strong API contracts.",
		"Keep user experience and business value aligned across product, design, and delivery.",
	],
	experience: [
		{
			title: process.env.REACT_APP_COMPANY_1_ROLE || "Full Stack Developer",
			company: process.env.REACT_APP_COMPANY_1_NAME || "Current Company LLP",
			location: process.env.REACT_APP_LOCATION || "Jamnagar, Gujarat",
			range: getRange(
				process.env.REACT_APP_COMPANY_1_START_DATE,
				process.env.REACT_APP_COMPANY_1_END_DATE,
				"03/2026 – Present"
			),
			bullets: parseList(
				process.env.REACT_APP_COMPANY_1_DESCRIPTION_LIST,
				[
					"Delivered responsive Angular pages and reusable component libraries for cross-device users.",
					"Connected frontend features to backend services using REST APIs and clean service patterns.",
					"Built maintainable APIs with Django REST Framework and integrated PostgreSQL data stores.",
					"Shipped bug fixes, feature enhancements, and performance improvements on a daily sprint cadence.",
				]
			),
		},
		{
			title: process.env.REACT_APP_COMPANY_2_ROLE || "Full Stack Developer Intern",
			company: process.env.REACT_APP_COMPANY_2_NAME || "Internship Company LLP",
			location: process.env.REACT_APP_LOCATION || "Jamnagar, Gujarat",
			range: getRange(
				process.env.REACT_APP_COMPANY_2_START_DATE,
				process.env.REACT_APP_COMPANY_2_END_DATE,
				"10/2025 – 01/2026"
			),
			bullets: parseList(
				process.env.REACT_APP_COMPANY_2_DESCRIPTION_LIST,
				[
					"Created React.js interfaces and reusable UI patterns with functional components and Hooks.",
					"Designed backend endpoints using Node.js, Express.js, and RESTful conventions.",
					"Implemented CRUD flows and database queries in MySQL for live application data.",
					"Collaborated with Git-based workflows, documentation, and testing best practices.",
				]
			),
		},
	],
		projects: [
		{
			title: process.env.REACT_APP_PROJECT_1_TITLE || "Simple Task Management Tool",
			category: process.env.REACT_APP_PROJECT_1_CATEGORY || "Spring Boot",
			summary: process.env.REACT_APP_PROJECT_1_SUMMARY || "Designed a task manager application with CRUD operations. Learned backend logic using Spring Boot and database connectivity.",
			image: "taskmanager.jpg",
			tech: parseList(process.env.REACT_APP_PROJECT_1_TECH, ["Spring Boot", "MySQL", "REST APIs", "Java"]),
			github: process.env.REACT_APP_PROJECT_1_GITHUB || "https://github.com/your-username/task-manager",
			demo: process.env.REACT_APP_PROJECT_1_DEMO || "https://task-manager-demo.com",
		},
		{
			title: process.env.REACT_APP_PROJECT_2_TITLE || "Airport Management System (AMS)",
			category: process.env.REACT_APP_PROJECT_2_CATEGORY || "C#.NET",
			summary: process.env.REACT_APP_PROJECT_2_SUMMARY || "Built a management system for airport operations and record handling.",
			image: "ams-01.png",
			tech: parseList(process.env.REACT_APP_PROJECT_2_TECH, ["C#.NET", "MS SQL Server", "WPF", "Entity Framework"]),
			github: process.env.REACT_APP_PROJECT_2_GITHUB || "https://github.com/your-username/airport-management",
			demo: process.env.REACT_APP_PROJECT_2_DEMO || "https://ams-demo.com",
		},
		{
			title: process.env.REACT_APP_PROJECT_3_TITLE || "Elite Estate (EE)",
			category: process.env.REACT_APP_PROJECT_3_CATEGORY || "Java",
			summary: process.env.REACT_APP_PROJECT_3_SUMMARY || "Developed a property listing and management application with database integration.",
			image: "ee-01.png",
			tech: parseList(process.env.REACT_APP_PROJECT_3_TECH, ["Java", "MySQL", "REST APIs", "Hibernate"]),
			github: process.env.REACT_APP_PROJECT_3_GITHUB || "https://github.com/your-username/elite-estate",
			demo: process.env.REACT_APP_PROJECT_3_DEMO || "https://elite-estate-demo.com",
		},
	],
	skills: [
		{
			category: "Frontend",
			items: ["HTML", "CSS", "JavaScript", "React.js", "Angular"],
		},
		{
			category: "Backend",
			items: ["Node.js", "Express.js", "Spring Boot", "Django REST", "Java"],
		},
		{
			category: "Tools & Data",
			items: ["MySQL", "PostgreSQL", "Git", "REST APIs", "Figma", "Jira"],
		},
	],
	education: [
		{
			degree: "MCA",
			institution: "JVIMS KBS-MCA College (G.T.U.)",
			range: "09/2024 – 04/2026",
			note: "CPI 8.56",
		},
		{
			degree: "BCA",
			institution:
				"Bhavan's Shree H. J. Doshi I.T. Institute (Saurashtra University)",
			range: "08/2021 – 03/2024",
			note: "77.33% / CGPA 8.31",
		},
	],
	certifications: ["Scaler.com — Java Course: Mastering the Fundamentals"],
};
